// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-6ccb0b14] {\n  grid-template-columns: repeat(7, 1fr);\n}\n.item-panel[data-v-6ccb0b14]:last-of-type {\n  background: none;\n  color: #202d78;\n}", ""]);
// Exports
module.exports = exports;
